import React, { Component } from "react"
import PropTypes from "prop-types"

import { Nav, Navbar, NavItem, Glyphicon, Image } from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"

import { Map } from "immutable"

import * as actionCreators from "../actions"

import logo from "./logo-white.png"

class MyNav extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  }

  state = {}

  handleSelect = eventKey => {
    // console.log("eventKey:", eventKey)
    switch (eventKey) {
      case 99:
        return this.props.actions.logout()
      default:
    }
  }

  render() {
    if (!this.props.auth.get("isAuthenticated"))
      return null

    return (
      <Navbar inverse collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <LinkContainer to="/orders">
              <a><Image src={logo} width="100" /></a>
            </LinkContainer>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <LinkContainer to="/orders">
              <NavItem eventKey={1}>Dashboard</NavItem>
            </LinkContainer>
            <LinkContainer to="/returns">
              <NavItem eventKey={2}>Retur</NavItem>
            </LinkContainer>
            <LinkContainer to="/expenses">
              <NavItem eventKey={2}>Expense</NavItem>
            </LinkContainer>
            <LinkContainer to="/reports">
              <NavItem eventKey={3}>Report</NavItem>
            </LinkContainer>
            <LinkContainer to="/dealers">
              <NavItem eventKey={4}>Dealer</NavItem>
            </LinkContainer>
            <LinkContainer to="/users">
              <NavItem eventKey={5}>User</NavItem>
            </LinkContainer>
          </Nav>
          <Nav pullRight onSelect={this.handleSelect}>
            <LinkContainer to="/myprofile">
              <NavItem eventKey={91}><Glyphicon glyph="user" /></NavItem>
            </LinkContainer>
            <NavItem eventKey={99}>Logout</NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  auth: state.get("auth") || Map(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyNav)



// WEBPACK FOOTER //
// ./src/components/MyNav.js